import { render, staticRenderFns } from "./invalidatePage.vue?vue&type=template&id=9b1c2150&scoped=true&"
import script from "./invalidatePage.vue?vue&type=script&lang=js&"
export * from "./invalidatePage.vue?vue&type=script&lang=js&"
import style0 from "./invalidatePage.vue?vue&type=style&index=0&id=9b1c2150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1c2150",
  null
  
)

export default component.exports